import { ReactNode, isValidElement } from 'react'

export const isChildText = (child: ReactNode): boolean => {
  if (typeof child === 'string') {
    return child.replace(/\s/g, '').length > 0
  } else if (isValidElement(child) && typeof child?.props?.children === 'string') {
    return child.props.children.replace(/\s/g, '').length > 0
  } else {
    return false
  }
}

export const getChildName = (child: ReactNode): string | boolean =>
  isValidElement(child) && typeof child.type !== 'undefined' && typeof child.type !== 'string' && child.type.name

export const getChildProps = (child: ReactNode): any => isValidElement(child) && child.props
